import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
//  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button, 
  LinearProgress,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const ClientTable = props => {
  const { 
    className, 
    userRole,
    clients, 
    onSetSelectedClients,
    onClickOpenRegister,
    onClickOpenEdit,
    onClickOpenDelete,
    disableEditButton,
    disableDeleteButton,
    
    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest } = props;

  const classes = useStyles();

  const [selectedClients, setSelectedClients] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedClients;

    if (event.target.checked) {
      selectedClients = clients.map(client => client.id);
    } else {
      selectedClients = [];
    }

    setSelectedClients(selectedClients);
    onSetSelectedClients(selectedClients);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedClients.indexOf(id);
    let newSelectedClients = [];

    if (selectedIndex === -1) {
      newSelectedClients = newSelectedClients.concat(selectedClients, id);
    } else if (selectedIndex === 0) {
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(1));
    } else if (selectedIndex === selectedClients.length - 1) {
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedClients = newSelectedClients.concat(
        selectedClients.slice(0, selectedIndex),
        selectedClients.slice(selectedIndex + 1)
      );
    }

    setSelectedClients(newSelectedClients);
    onSetSelectedClients(newSelectedClients);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  // };


  // const [openAlert, setOpenAlert] = useState(false);

  // const handleClickOpenAlert = () => {
  //   setOpenAlert(true);
  // };

  // const handleCloseAlert = () => {
  //   setOpenAlert(false);
  // };


  useEffect(() => {
    //console.log('componentDidUpdate & clients changed');

    const newSelected = selectedClients.filter(id => {
      const findObj = clients.find(obj => obj.id === id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedClients(newSelected);
    onSetSelectedClients(newSelected);

  }, [clients]);

  return (
    <div>

      {userRole !== 'user' && (
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegister }
          >
            등록
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEdit }
          >
            수정
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDelete }
          >
            삭제
          </Button>

        </div>
      )}

      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {openProgress && <LinearProgress /> }
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={clients.length > 0 && selectedClients.length === clients.length}
                        color="primary"
                        indeterminate={
                          selectedClients.length > 0 &&
                          selectedClients.length < clients.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>번호</TableCell>
                    <TableCell>광고주명</TableCell>
                    <TableCell>광고대행사</TableCell>
                    <TableCell>계약상태</TableCell>
                    <TableCell>거래담당자</TableCell>
                    <TableCell>전화번호</TableCell>
                    <TableCell>등록일</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clients.map((client, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={client.id}
                      selected={selectedClients.indexOf(client.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedClients.indexOf(client.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, client.id)}
                          value="true"
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          {/* <Avatar
                            className={classes.avatar}
                            src={category.avatarUrl}
                          >
                            {getInitials(category.name)}
                          </Avatar> */}
                          <Typography variant="body1">{client.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{client.agency}</TableCell>
                      <TableCell>{client.contract}</TableCell>
                      <TableCell>{client.manager}</TableCell>
                      <TableCell>{client.tel}</TableCell>
                      <TableCell>
                        {moment(client.regAt).format('YYYY-MM-DD')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            labelRowsPerPage=''
            component="div"
            count={item_total}
            onChangePage={onPageChange}
            onChangeRowsPerPage={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>

    </div>
  );
};

ClientTable.propTypes = {
  className: PropTypes.string,
  clients: PropTypes.array.isRequired
};


ClientTable.defaultProps = {
  clients: [],
};


export default ClientTable;
